<template>
    <a-modal width="85%" title="查看详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
        <template #footer>
            <a-button key="back" @click="onClose">取消</a-button>
        </template>
        <a-form ref="ruleForm" layout="vertical" :model="form"  @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id" />
                </a-form-item>
            </div>
            <div>
                <a-descriptions title="项目基本信息" :column="2">
                    <a-descriptions-item label="企业名称">{{ form.companyName }}</a-descriptions-item>
                    <a-descriptions-item label="项目名称">
                        <dict-render :dict-obj= "dictObjs['FundTrackingSubsidyType']" :text="form.subsidyType"></dict-render>
                    </a-descriptions-item>
                    <a-descriptions-item label="项目编号">{{ form.projectNumber }}</a-descriptions-item>
                    <a-descriptions-item label="申请类别">{{ form.applicationType }}</a-descriptions-item>
                    <a-descriptions-item label="补助时间">{{ momentFormat(form.subsidyTime , 'YYYY-MM-DD') }}</a-descriptions-item>
                    <a-descriptions-item label="资助金额（万元）">{{ form.amountApplied }} 万元</a-descriptions-item>
                    <a-descriptions-item label="企业负责人">{{ form.companyRespon }}</a-descriptions-item>
                    <a-descriptions-item label="联系电话">{{ form.companyPhone }}</a-descriptions-item>
                    <a-descriptions-item label="项目负责人">{{ form.projectRespon }}</a-descriptions-item>
                    <a-descriptions-item label="联系电话">{{ form.projectPhone }}</a-descriptions-item>
                </a-descriptions>
                <!--<a-descriptions title="2、项目总体执行情况（每个月项目进展情况）">
                    <a-form-item name="projectExecution">
                        <a-textarea
                            :disabled="true"
                            v-model:value="form.projectExecution"
                            :auto-size="{ minRows: 2, maxRows: 5 }"
                        />
                    </a-form-item>
                    <a-textarea
                        v-model:value="form.projectExecution"
                        placeholder="请输入项目总体执行情况"
                        :auto-size="{ minRows: 2, maxRows: 5 }"
                    />
                </a-descriptions>

                <a-descriptions title="3、项目资金筹措及资金使用情况（单位：万元）" :column="2">
                    <a-descriptions-item label="总投资">{{ form.amountTotal }}</a-descriptions-item>
                    <a-descriptions-item label="自筹">{{ form.amountSince }}</a-descriptions-item>
                    <a-descriptions-item label="贷款">{{ form.amountLoan }}</a-descriptions-item>
                    <a-descriptions-item label="科技资金资助金额">{{ form.amountApplied }}</a-descriptions-item>
                    <a-descriptions-item label="政府其他拨款">{{ form.amountGovernment }}</a-descriptions-item>
                    <a-descriptions-item label="其他">{{ form.amountOther }}</a-descriptions-item>
                </a-descriptions>-->
<!--                <a-descriptions title="印证资料" >
                    <a-descriptions-item label="其他相应印证资料" name="confirmationFile">
                        <file-upload v-model:value="form.confirmationFile" :showBtn="false" disabled />
                    </a-descriptions-item>
                </a-descriptions>-->

            </div>
            <div>
                <a-row :gutter="[24, 8]">
                    <a-col :span="24">
                        <a-form-item name="enterpriseFundExpenditureList">
                            <a-descriptions title="高新区奖励资金支出情况" :column="2"></a-descriptions>
                            <a-table :columns="columns" :data-source="form.enterpriseFundExpenditureList" bordered :pagination="false">
                                <template #customTitle1>
                                    <div>
                                        <span style="color: #ff4d4f;">*</span> 使用范围
                                    </div>
                                </template>
                                <template #customTitle2>
                                    <div>
                                        <span style="color: #ff4d4f;">*</span> 供货单位
                                    </div>
                                </template>
                                <template #customTitle3>
                                    <div>
                                        <span style="color: #ff4d4f;">*</span> 金额(万元)
                                    </div>
                                </template>
                                <template #customTitle5>
                                    <div>
                                        印证材料
                                    </div>
                                </template>
                                <template #customTitle4>
                                    <div>
                                        备注
                                    </div>
                                </template>
                                <template #amount="{ record }">
                                    <span>{{record.amount}}</span>
                                </template>
                                <template #scopeOfUse="{ text }">
                                    <DictRender :dict-obj="dictObjs['Scope_of_use']" :text="text" />
                                </template>
                                <template #supplyUnit="{ record }">
                                    <span>{{record.supplyUnit}}</span>
                                </template>
                                <template #expenditureFile="{ record }">
                                    <file-upload v-model:value="record.expenditureFile" :showBtn="false" disabled />
                                </template>
                                <template #remark="{ record }">
                                    <span>{{record.remark}}</span>
                                </template>
                            </a-table>
                        </a-form-item>
                    </a-col>
                </a-row>
            </div>
            <div>
                <a-descriptions title="审核信息" :column="2">
                    <a-descriptions-item label="审核信息">
                        <span v-if="form.auditStatus==0" style="color:green">未审核</span>
                        <span v-if="form.auditStatus==1" style="color:green">通过</span>
                        <span v-if="form.auditStatus==2" style="color:red">不通过</span>
                    </a-descriptions-item>
                    <a-descriptions-item label="审核原因" :span="2">{{ form.firstAuditRemark }}</a-descriptions-item>
                </a-descriptions>
            </div>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import { formMixin, dictMixin } from "@/mixins";
import {sys_policy,} from "@/api/policyService";
import DictRender from "@/components/other/DictRender";
import { policy, dateFormat } from "@/config/variableConfig";
import { message } from "ant-design-vue";
import { ls } from "@/utils/util";
import { file_service } from "@/api/adminService";
import axios from "axios";

const columns = [
    {title: "序号", dataIndex: "sortNum", key: "sortNum"},
    {dataIndex: "scopeOfUse", slots: {title: 'customTitle1',customRender: "scopeOfUse"}},
    {dataIndex: "supplyUnit", slots: {title: 'customTitle2',customRender: "supplyUnit"}},
    {dataIndex: "amount",slots: {title: 'customTitle3',customRender: "amount"}},
    {dataIndex: "expenditureFile",slots: {title: 'customTitle5',customRender: "expenditureFile"}},
    { dataIndex: "remark", slots: {title: 'customTitle4',customRender: "remark"}},
];
export default {
    name: "DetailModal",
    components: { DictRender },
    mixins: [formMixin, dictMixin],
    data() {
        return {
            obs: false,
            dictNames: 'FundTrackingSubsidyType,Scope_of_use',
            columns,
            policy,
            dateFormat,
            isAllowVisible: false,
            form: {
                id: null,
                enterpriseFundExpenditureList: []
            },
            editableData: {},
        }
    },
    methods: {
        getIsAllowData(value) {
            this.getAction({
                url: sys_policy.isFillIn + value
            }).then(res => {
                if (res) {
                    this.postAction({
                        url: sys_policy.isAllow,
                        params: { cashingTypeValue: '0', year: value }
                    }).then(res => {
                        if (res.result == 'false') {
                            message.warning('不在兑现时间范围内！', this.resetForm)
                        } else {
                            this.form.firstReviewer = res.firstReviewer
                            this.form.secondReviewer = res.secondReviewer
                        }
                    })
                } else {
                    // this.isAllowVisible = true
                }
            })
        },
        handleOk() {
            this.$router.push({ path: '/sys/manage' })
        },
        resetForm() {
            this.$refs.ruleForm.resetFields('year')
        },
        getMoban() {
            if (this.form.year) {
                this.postAction({
                    url: sys_policy.getMoban,
                    params: { cashingTypeValue: '0', year: this.form.year }
                }).then(res => {
                    this.fileDowload(res)
                })
            } else {
                message.warning('请选择年份！')
            }
        },
        fileDowload(r) {
            if (r) {
                let name = r.split('|')[1];
                axios({
                    methods: 'get',
                    url: file_service.download + r,
                    responseType: 'blob',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                        Authorization: 'Bearer' + ls.get('token') || ''
                    }
                }).then(data => {
                    const blob = new Blob([data.data], { type: "application/vnd.ms-excel;charset=utf-8" });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a"); // 创建a标签
                    link.href = url;
                    link.download = decodeURIComponent(name);// 文件重命名，若无需重命名，将该行删去
                    link.click();
                    URL.revokeObjectURL(url); // 释放内存
                })
            } else {
                message.warning('请确认承诺书是否已经上传！')
            }
        },
        handleAdd() {
            const newData = {
                sortNum: this.form.enterpriseFundExpenditureList ? this.form.enterpriseFundExpenditureList.length + 1 : 1,
                amount: '',
                supplyUnit: '',
                remark: '',
            }
            this.form.enterpriseFundExpenditureList.push(newData)
        },
        deleteLine(key) {
            this.form.enterpriseFundExpenditureList = this.form.enterpriseFundExpenditureList.filter(item => item.sortNum !== key);
        },
        changeData(record) {
            if (record.intellectualPropertyType == '1' || record.intellectualPropertyType == '3') {
                delete record.otherFile1
                delete record.otherFile2
            }
        },
        onSubmitFun() {
            this.form.isSubmit = 1
            this.onSubmit()
        }
    },
    watch: {
        visible: {
            handler(oldValue) {
                if (this.form.yearArr.length == 1) {
                    if (oldValue) {
                        this.getIsAllowData(this.form.year)
                    }
                }
            },
        }
    }
}
</script>
<style scoped lang="less">
:deep(.ant-table-body) {
    //min-height: 300px;
}

:deep(.ant-table-placeholder) {
    display: none;
}
.title-01{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
}
</style>
